import { BREAKPOINT_LARGE, BREAKPOINT_MED, HTML_WIDTH } from '../variables';

export default function initSlickSliders() {
  initRelatedProductsSlick();
  initCrossSellSlickSlider();
  initWlHandpickedProductsSlick();
  initWcHandpickedProductsSlider();
  initCombinedProductsSlickSlider();

  setTimeout(() => {
    checkforSlidersInProductList();
  }, 1000); // Kör denna på rejäl timeout. Har inget bra sätt att avgöra när DOMen är redo för att initiera slidern
}

export function checkforSlidersInProductList() {
  if (HTML_WIDTH > BREAKPOINT_LARGE || !document.querySelector('.products .product'))
    return;

  const productsInList = [...document.querySelectorAll('.products .product, .products .related-item')];

  for (const listProduct of productsInList) {
    // TODO denna ska väl för fan bara kolla efter bilder!JQEWOIUFEWHDisdfubw
    // if (listProduct.querySelectorAll(':scope > a > img, :scope > a > div').length === 2 && !listProduct.querySelector('.slick')) {
    if (listProduct.querySelectorAll(':scope > a > *').length === 2 && !listProduct.querySelector('.slick')) {
      $(listProduct.querySelector('.woocommerce-LoopProduct-link:not(.slick-initialized)')).css('display', 'block').css('overflow', 'hidden');
      $(listProduct.querySelectorAll(':scope > a > *')).css('width', '100%');
      $(listProduct.querySelector('.woocommerce-LoopProduct-link:not(.slick-initialized)')).slick({
        arrows: false,
        dots: true,
        draggable: false,
        infinite: false,
        slidesToShow: 1
      });

      listProduct.addEventListener('click', e => {
        if (e.target.type === 'button')
          e.preventDefault();
      });
    }
  }
}

function initWlHandpickedProductsSlick() {
  $('.wl-handpicked-products').each(function(index, key) {
    if (HTML_WIDTH < BREAKPOINT_MED && $('.product', this).length < 2)
      return;

    if (HTML_WIDTH > BREAKPOINT_MED && $('.product', this).length < 4)
      return;

    if (HTML_WIDTH > BREAKPOINT_LARGE && $('.product', this).length < 5)
      return;

    const tmpId = 'slider' + index;
    $(this).attr('id', tmpId);
    $('#' + tmpId).slick({
      slidesToShow: 4,
      focusOnSelect: false,
      infinite: false,
      nextArrow: '<button type="button" class="slide-products-next"></button>',
      prevArrow: '<button type="button" class="slide-products-prev"></button>',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  });
}

function initWcHandpickedProductsSlider() {
  $('.wc-block-grid__products').each(function(index, key) {
    if (HTML_WIDTH > BREAKPOINT_MED && $('.product', this).length < 3)
      return;

    const tmpId = 'slider' + index;
    $(this).attr('id', tmpId);
    $('#' + tmpId).slick({
      slidesToShow: 4,
      focusOnSelect: false,
      nextArrow: '<button type="button" class="slide-products-next"></button>',
      prevArrow: '<button type="button" class="slide-products-prev"></button>',
      responsive: [
        {
          breakpoint: 769,
          settings: {
            centerPadding: '0',
            centerMode: true,
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            centerMode: false,
            slidesToShow: 2
          }
        }
      ]
    });
  });
}

function initRelatedProductsSlick() {
  $('.product .related .products').slick({
    slidesToShow: 4,
    focusOnSelect: false,
    nextArrow: '<button type="button" class="slick-next"></button>',
    prevArrow: '<button type="button" class="slick-prev"></button>',
    responsive: [
      {
        breakpoint: 769,
        settings: {
          centerPadding: '0',
          centerMode: true,
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          centerMode: false,
          slidesToShow: 2
        }
      }
    ]
  });
}

function initCombinedProductsSlickSlider() {
  if (!$('.products.combines-with').length)
    return;

  if (HTML_WIDTH < BREAKPOINT_MED && $('.products.combines-with .product').length < 2)
    return;

  if (HTML_WIDTH > BREAKPOINT_MED && $('.products.combines-with .product').length < 4)
    return;

  if (HTML_WIDTH > BREAKPOINT_LARGE && $('.products.combines-with .product').length < 5)
    return;

  $('.products.combines-with').slick({
    slidesToShow: 4,
    focusOnSelect: false,
    nextArrow: '<button type="button" class="slick-next"></button>',
    prevArrow: '<button type="button" class="slick-prev"></button>',
    responsive: [
      {
        breakpoint: 769,
        settings: {
          centerPadding: '0',
          centerMode: false,
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          centerMode: false,
          slidesToShow: 2
        }
      }
    ]
  });
}

function initCrossSellSlickSlider() {
  // Om produkten har korsförsäljning så bygg om listan till slider
  if (!$('.product .related.products > .product').length)
    return;

  $('.product .related.products').slick({
    slidesToShow: 4,
    focusOnSelect: false,
    nextArrow: '<button type="button" class="slick-next"></button>',
    prevArrow: '<button type="button" class="slick-prev"></button>',
    responsive: [
      {
        breakpoint: 769,
        settings: {
          centerPadding: '0',
          centerMode: true,
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          centerMode: false,
          slidesToShow: 2
        }
      }
    ]
  });
}
